<template>
  <div class="comp-table-msg-center">
    <el-table
      :data="tableData"
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column
        class-name="border-right-column"
        prop="index"
        align="left"
        label=""
        width="80">
      </el-table-column>
      <el-table-column
        prop="title"
        label="消息标题"
        align="left"
      >
        <template slot-scope="scope">
          <p href="javascript:void(0);" class="message-title new_icon" @click="showDetail(scope.row)">
            {{scope.row.title.length > 36 ? scope.row.title.slice(0, 35) + '...' : scope.row.title }}
            <img v-if="!scope.row.is_read" :src="imgUrl" alt="" class="icon-new">
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="publish_time"
        label="推送日期"
        width="326">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalRecords">
    </el-pagination>
    <messageDialog ref="m_dialog" @close="closeDialog"></messageDialog>
  </div>
</template>
<script>
  import imgUrl from '../../assets/images/icon-new.png';
  import messageDialog from '../MessageDialog/MessageDialog.vue';

  export default {
    data () {
      return {
        tableData: [],
        currentPage: 1,
        size: 10,
        totalRecords: 0,
        loading: true,
        imgUrl
      };
    },
    components: {
      messageDialog
    },
    created () {
      this.query();
    },
    methods: {
      query: function () {
        //消息中心 所有消息
        let _this = this;
        let data = {
          platform: this.$agency.isHQ ? 'HQ' : 'IRS',
          isRead: 2,
          start: this.currentPage - 1,
          size: this.size
        };
        _this.loading = true;
        _this.tableData = [];
        _this.$axios.post('/crm-api/ces-web/user/api/v3/message/totalList', _this.$qs.stringify(data)).then((res) => {
          _this.totalRecords = res.data.total;
          _this.loading = false;
          _this.tableData = res.data.list;
          _this.tableData.forEach((item, i) => {
            item.index = data.start * data.size + i + 1;
          });
        });
      },
      handleSizeChange: function (size) {
        this.size = size;
        this.query();
      },
      handleCurrentChange: function (currentPage) {
        this.currentPage = currentPage;
        this.query();
      },
      showDetail: function (message) {
        let _this = this;
        _this.$refs.m_dialog.show(message.id, 1, false, this.$agency.isHQ);
      },
      closeDialog: function () {
        this.query();
      }
    }
  };
</script>
<style lang="less">
  .comp-table-msg-center {
    margin-top: 10px;
    background: white;
    padding: 10px;
    border: 1px solid #DCDCDC;
    .el-table .el-table__header-wrapper {
      border: none;
    }
    .el-table__body {
      font-size: 12px;
    }
    .message-title {
      cursor: pointer;
      line-height: 40px;
      color: #016cdf;
      .icon-new {
        width: 26px;
        padding-left: 12px;
      }
    }
    .message-title:hover {
      color: #1083ff;
    }
  }
</style>




// WEBPACK FOOTER //
// MessageCenter.vue?154691f2